import React from "react";

import * as S from "./styles";
import { TDSButton } from "./types";

const DSButton: React.FC<TDSButton> = ({
  fullWidth = false,
  isDisabled = false,
  isLoading = false,
  buttonType,
  isCancelType,
  height,
  buttonText,
  fontSize,
  icon,
  width,
  opacityOnHover,
  isIconAfter = false,
  dataTestId,
  ...rest
}) => {
  return (
    <S.Button
      fullWidth={fullWidth}
      isDisabled={isDisabled}
      buttonType={buttonType}
      isCancelType={isCancelType}
      opacityOnHover={opacityOnHover}
      style={{
        height,
        width: fullWidth ? "100%" : width,
        fontSize,
      }}
      data-cy={dataTestId}
      data-testid={dataTestId}
      {...rest}
    >
      {isLoading && (
        <S.Loader
          buttonType={buttonType as "primary" | "secondary"}
          data-testid="loading-btn"
        />
      )}{" "}
      {icon && !isLoading && !isIconAfter && icon}
      {buttonText}
      {icon && !isLoading && isIconAfter && icon}
    </S.Button>
  );
};

export default DSButton;
